import clsx from 'clsx'

import TrackRowSkeleton from '../TrackRow/TrackRow.skeleton'
import styles from './TrackList.module.css'
import { TrackListSkeletonProps } from './TrackList.skeleton.types'

const TrackListSkeleton = ({
	count = 10,
}: TrackListSkeletonProps): JSX.Element => {
	return (
		<div
			className={clsx(styles.trackList, styles.trackListSkeleton)}
			data-testid="track-list-skeleton"
		>
			{Array(count)
				.fill(0)
				.map((_, index) => (
					<div className={styles.trackListItem} key={`skeleton-${index}`}>
						<TrackRowSkeleton />
					</div>
				))}
		</div>
	)
}

export default TrackListSkeleton
